import React, { useState, useEffect } from "react";

import { BingoSheetPagination } from "./Pagination";
import { BingoSheetArea, BingoSheetGrid, BingoSheetGridNumberCell } from "./styles";

type BingoSheetItemsProps = {
  startingNumber: number;
  quantity: number;
};

export function BingoSheetItems({ startingNumber, quantity }: BingoSheetItemsProps) {
  const [currentPage, setCurrentPage] = useState(1);
  const [display, setDisplay] = useState(100);

  const quantityOfPages = Math.max(1, Math.ceil(quantity / display));

  useEffect(() => {
    if (quantity < 1) return;
    if (currentPage > quantityOfPages) {
      setCurrentPage(quantityOfPages);
    }
  }, [quantity, display, quantityOfPages, currentPage]);

  if (quantity < 1) return null;

  const getItemsToDisplay = () => {
    const itemsShownSoFar = (currentPage - 1) * display;
    const remainingItems = quantity - itemsShownSoFar;
    return Math.max(0, Math.min(display, remainingItems));
  };

  const startIndexNumber = startingNumber + (currentPage - 1) * display;
  const count = getItemsToDisplay();

  return (
    <div>
      <BingoSheetArea>
        <BingoSheetGrid>
          {Array.from({ length: count }, (_, i) => {
            const globalIndex = (currentPage - 1) * display + i;
            const itemNumber = startIndexNumber + i;
            return (
              <BingoSheetGridNumberCell key={globalIndex} aria-hidden>
                {itemNumber}
              </BingoSheetGridNumberCell>
            );
          })}
        </BingoSheetGrid>
      </BingoSheetArea>
      <BingoSheetPagination
        itemQuantity={quantity}
        currentDisplay={display}
        setCurrentDisplay={setDisplay}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}
